import { render, staticRenderFns } from "./box.vue?vue&type=template&id=832d3432&scoped=true"
import script from "./box.vue?vue&type=script&lang=ts"
export * from "./box.vue?vue&type=script&lang=ts"
import style0 from "./box.vue?vue&type=style&index=0&id=832d3432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "832d3432",
  null
  
)

export default component.exports